import { useEffect, useState } from 'react';
import { card41Api } from '../../../api/card41.js';

/** Флаг доступа к «Карточке 41» из /api/admin/card41/access (admin или CARD41_USERS); клиентам раздел закрыт. */
export function useCard41Access(role: string | null): boolean {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    if (!role || role === 'client') { setEnabled(false); return undefined; }
    let alive = true;
    card41Api.access()
      .then((r) => { if (alive) setEnabled(r.enabled); })
      .catch(() => { if (alive) setEnabled(false); });
    return () => { alive = false; };
  }, [role]);
  return enabled;
}
